'use strict';

var richTextTypes = require('@contentful/rich-text-types');

function documentToPlainTextString(rootNode, blockDivisor = ' ', options = {}) {
    if (!rootNode || !rootNode.content || !Array.isArray(rootNode.content)) {
        return '';
    }
    let processedRootNode = rootNode;
    if (rootNode.nodeType === richTextTypes.BLOCKS.DOCUMENT && options.stripEmptyTrailingParagraph) {
        processedRootNode = richTextTypes.helpers.stripEmptyTrailingParagraphFromDocument(rootNode);
    }
    return processedRootNode.content.reduce((acc, node, i)=>{
        let nodeTextValue;
        if (richTextTypes.helpers.isText(node)) {
            nodeTextValue = node.value;
        } else if (richTextTypes.helpers.isBlock(node) || richTextTypes.helpers.isInline(node)) {
            nodeTextValue = documentToPlainTextString(node, blockDivisor, options);
            if (!nodeTextValue.length) {
                return acc;
            }
        }
        const nextNode = processedRootNode.content[i + 1];
        const isNextNodeBlock = nextNode && richTextTypes.helpers.isBlock(nextNode);
        const divisor = isNextNodeBlock ? blockDivisor : '';
        return acc + nodeTextValue + divisor;
    }, '');
}

exports.documentToPlainTextString = documentToPlainTextString;
//# sourceMappingURL=rich-text-plain-text-renderer.es5.js.map
